module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_logos_mobile.9539aac6.svg";